import validate from "/usr/src/app/content/n3-spas-cf48a8ed-d650-4995-af16-132c360cf639/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-cf48a8ed-d650-4995-af16-132c360cf639/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}